export default {
  headless: () => import("/src/Frontend/layouts/Headless.vue"),
  default: () => import("/src/Frontend/layouts/default.vue")
}